import Carousel from '../../../../../baseComponents/gui/carousel/Carousel';
import CustomButton from '../../../../customButton/ui/main/CustomButton';
import { safeHTML } from '../../../../../../utils/safeHTML';
import { useTranslation } from '../../../../../../translations';
import classNames from 'classnames';
import PrizeItem from '../PrizeItem/PrizeItem';
import content from '../../../constants/content';

const { modal } = content;

export default function MyPrizes({ status, myPrizes }) {
  const { subtext, navigation, carousel } = modal[status];
  const { t } = useTranslation();

  return (
    !!myPrizes?.length && (
      <div className={'drawing-result-modal__prize'}>
        <div className={`drawing-result-modal__prize-bg`} />
        <div className={'drawing-result-modal__prize-block'}>
          {myPrizes?.length > 1 ? (
            <>
              <Carousel settings={{ ...carousel }} itemsData={myPrizes} item={PrizeItem} />
              {navigation?.map?.((id, index) => (
                <CustomButton
                  key={id}
                  className={classNames(
                    'custom-button_icon',
                    'drawing-result-modal__prize-nav',
                    `drawing-result-modal__prize-nav_${id}`,
                  )}
                  icon={'buttons/winnings-nav-2'}
                />
              ))}
            </>
          ) : (
            <PrizeItem {...myPrizes[0]} />
          )}
        </div>
        {subtext && <h4 className={'drawing-result-modal__prize-subtext'}>{safeHTML(t(subtext))}</h4>}
      </div>
    )
  );
}
